import { setting } from '@/Helpers.js';
import store from '@/store/Index.js';

export default async (to, from, next) => {
    if (store.state.Auth.user) {
        next();

        return;
    }

    await store.dispatch('Auth/fetchUser');

    if (to.name === 'home' && to.query.redirect) {
        next(to.query.redirect);

        return;
    }

    if (!store.getters['Auth/check']) {
        if (setting('manual_login_enabled')) {
            // If in debug mode and auth fails only allow home, login, and password reset routes

            if (['home', 'login', 'password.request', 'password.reset'].some(check => check === to.name)) {
                next();
            } else {
                next({ name: 'login', query: { redirect: to.path } });
            }
        } else {
            window.location = `/saml2/login?redirect=${to.path}`;

            return;
        }
    }

    // eslint-disable-next-line consistent-return
    return next();
};
